import React, {
  useEffect,
  useMemo,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Form, Input } from "antd";
import "./modal.scss";
import { SvgIcon } from "../SvgIcon";
import { useTranslation } from "react-i18next";

export interface MoreProps {
  pageType: "order" | "personal";

  //   // 3:电子发票（普通发票）;4:电子发票（增值税专用发票）
  //   billType: 3 | 4;
}

export interface MoreRef {
  setOpen: (isOpen: boolean) => void;
}

const More = forwardRef<MoreRef, MoreProps>(({ pageType = "order" }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    setOpen: (open: boolean) => {
      setIsOpen(open);
    },
  }));

  //   const showOption = useMemo(() => {
  //     if (billType === 4) return false;
  //     return true;
  //   }, [billType]);

  const placeholder = useMemo(() => {
    return t("选填");
  }, [t]);

  return (
    <>
      <div
        style={
          isOpen
            ? { display: "block" }
            : {
                display: "none",
              }
        }
      >
        <Form.Item
          name={`${pageType === "order" ? "title_" : ""}bank_name`}
          label={t("开户银行")}
          rules={[
            ({}) => ({
              validator(_, value) {
                if (/\s/.test(value)) {
                  return Promise.reject(
                    new Error(`${t("请勿在银行名称中添加空格")}`)
                  );
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input placeholder={placeholder} maxLength={255} />
        </Form.Item>
        <Form.Item
          name={`${pageType === "order" ? "title_" : ""}bank_card_no`}
          label={t("银行账号")}
          rules={[
            {
              pattern: /^\d+$/i,
              message: t("银行账号为纯数字格式，请勿添加任何符号或空格"),
            },
          ]}
        >
          <Input placeholder={placeholder} maxLength={255} />
        </Form.Item>
        <Form.Item
          name={`${pageType === "order" ? "title_" : ""}address`}
          label={t("客户地址")}
          rules={[
            ({}) => ({
              validator(_, value) {
                if (/\s/.test(value)) {
                  return Promise.reject(
                    new Error(`${t("请勿在地址信息中添加空格")}`)
                  );
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input placeholder={placeholder} maxLength={255} />
        </Form.Item>
        <Form.Item
          name={`${pageType === "order" ? "title_" : ""}telephone`}
          label={t("客户电话")}
          rules={[
            {
              pattern: /^\d+[\-\d]*\d*$/i,
              message:
                t("请勿在电话号码中添加除") + "“-”" + t("以外的任何符号"),
            },
          ]}
        >
          <Input placeholder={placeholder} maxLength={32} />
        </Form.Item>
      </div>
      {isOpen ? (
        <Form.Item label={<div></div>} noStyle>
          <div onClick={() => setIsOpen(false)} className="more-btn">
            {`${t("收起")}`}
            <SvgIcon icon="icon-a-xianxingxiangshang" width={16} height={16} />
          </div>
        </Form.Item>
      ) : (
        <Form.Item label={<div></div>} noStyle>
          <div onClick={() => setIsOpen(true)} className="more-btn">
            {`${t("更多选填项")}`}{" "}
            <SvgIcon icon="icon-a-xianxingxiangxia" width={16} height={16} />
          </div>
        </Form.Item>
      )}
    </>
  );
});

export default More;
